
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetothanecabs() {



  const cardData =
  {
    keyword: 'Pune to Thane Cab Service',
    heading: 'AB Ghule Cabs: Pune to Thane Cab Service',
    headingDescription: 'Planning a trip from Pune to Thane? AB Ghule Cabs offers reliable, comfortable, and affordable taxi services for your journey from Pune to Thane. Whether you are traveling for business, leisure, or any other purpose, we provide seamless travel experiences with our well-maintained vehicles and experienced drivers. Enjoy a stress-free and comfortable ride as we take you from Pune to Thane in no time. The approximate distance from Pune to Thane is around 160 km.',

    top: 'Top Places to Visit in Thane with AB Ghule Cabs',

    topPlaces: [
        {
            title: "Kailash Mandir",
            description: "A well-known Hindu temple in Thane, Kailash Mandir is dedicated to Lord Shiva and is a peaceful place to visit for spiritual rejuvenation."
        },
        {
            title: "Upvan Lake",
            description: "A scenic spot for a peaceful day out, Upvan Lake offers a beautiful view of nature, making it perfect for picnics, boating, and relaxation by the lakeside."
        },
        {
            title: "Suraj Water Park",
            description: "Ideal for family fun, Suraj Water Park in Thane offers a variety of water rides and attractions. It’s a great place to enjoy a fun-filled day with friends and family."
        },
        {
            title: "Tikuji-ni-Wadi",
            description: "A popular amusement park and water park, Tikuji-ni-Wadi offers rides, water slides, and a relaxing environment for a fun day out with family and friends."
        },
        {
            title: "Masunda Lake (Talav Pali)",
            description: "Known for its historical significance, Masunda Lake is a popular recreational spot in Thane. The lake offers boating facilities and a peaceful atmosphere for visitors."
        },
        {
            title: "Sathaye College Garden",
            description: "A serene location for a quiet stroll, Sathaye College Garden is known for its lush greenery, making it a perfect place for relaxation and meditation."
        },
        {
            title: "Bassein Fort",
            description: "Located a short drive from Thane, Bassein Fort is a historical fort that dates back to the Portuguese era. It offers stunning views of the Arabian Sea and is a great spot for history enthusiasts."
        },
        {
            title: "Korum Mall",
            description: "For shopping, dining, and entertainment, Korum Mall in Thane is a popular destination with a wide variety of retail stores, restaurants, and a movie theater."
        },
        {
            title: "Ganesh Gully",
            description: "A famous alley in Thane known for its vibrant Ganesh celebrations, Ganesh Gully offers a lively atmosphere during the Ganesh festival and is a must-see for visitors interested in local traditions."
        },
        {
            title: "Nehru Science Center",
            description: "A great destination for children and science lovers, the Nehru Science Center offers educational exhibits, interactive displays, and activities related to science and technology."
        }
    ],


    services: [
        {
          "name": "Thane to Pune Cab Fare",
          description: "Check the competitive and transparent pricing for your Thane to Pune cab trip with AB Ghule Cabs. We offer affordable and reliable taxi services with no hidden charges, ensuring a cost-effective and comfortable journey."
        },
        {
          "name": "Cab from Thane to Pune",
          description: "Book your cab from Thane to Pune with AB Ghule Cabs. We offer smooth, comfortable, and affordable taxi services, ensuring a safe and pleasant ride from Thane to Pune and back."
        },
        {
          "name": "Pune to Kalyan Cab Service",
          description: "AB Ghule Cabs offers reliable Pune to Kalyan cab services. Our experienced drivers ensure a smooth and hassle-free journey with well-maintained vehicles, providing comfort and safety for your travel needs."
        },
        {
          "name": "Pune Thane Taxi",
          description: "For a reliable Pune to Thane taxi, AB Ghule Cabs offers comfortable and affordable options. We ensure a safe and timely ride with professional drivers and well-maintained vehicles, making your journey stress-free."
        },
        {
          "name": "Pune to Thane Cab Booking",
          description: "Book your Pune to Thane cab with AB Ghule Cabs. We offer easy booking options for a comfortable and reliable ride, whether it's for a one-way or round-trip journey."
        },
        {
          "name": "Pune to Thane Cab Fare",
          description: "Get the best rates for your Pune to Thane cab fare with AB Ghule Cabs. We provide competitive and transparent pricing with no hidden charges, offering the best value for your trip."
        },
        {
          "name": "Pune to Thane Cab Service",
          description: "AB Ghule Cabs offers efficient Pune to Thane cab services. Our fleet of well-maintained vehicles and experienced drivers ensure a safe, comfortable, and timely ride for your journey."
        },
        {
          "name": "Pune to Thane One Way Cab",
          description: "Book a one-way cab from Pune to Thane with AB Ghule Cabs. Our one-way taxi services provide a hassle-free and cost-effective travel experience with well-maintained vehicles and professional drivers."
        },
        {
          "name": "Pune to Thane Taxi Service",
          description: "AB Ghule Cabs provides reliable taxi services from Pune to Thane. Enjoy a comfortable and safe journey with experienced drivers and well-maintained vehicles, ensuring a smooth ride for your travel."
        },
        {
          "name": "Thane to Pune Cab Booking",
          description: "Book your cab from Thane to Pune with AB Ghule Cabs. We offer reliable and affordable taxi services with professional drivers, ensuring a safe and comfortable journey from Thane to Pune."
        },
        {
          "name": "Pune to Badlapur Cab",
          description: "Travel from Pune to Badlapur with AB Ghule Cabs. Our reliable cab service ensures you a smooth and comfortable ride, whether it's for business or leisure. We provide well-maintained vehicles and professional drivers."
        },
        {
          "name": "Pune to Vasai Virar Cab",
          description: "Book a cab from Pune to Vasai Virar with AB Ghule Cabs. Our taxi services are designed for a smooth and comfortable journey, offering well-maintained vehicles and experienced drivers to make your trip enjoyable."
        },
        {
          "name": "Pune to Vashi Cab",
          description: "Travel from Pune to Vashi with AB Ghule Cabs. Our reliable and affordable taxi service ensures a comfortable ride with experienced drivers, making your journey from Pune to Vashi hassle-free."
        },
        {
          "name": "Pune to Thane One Way Cab",
          description: "For a one-way trip from Pune to Thane, AB Ghule Cabs offers efficient and affordable taxi services. Enjoy a smooth journey with well-maintained vehicles and professional drivers ensuring comfort and safety."
        },
        {
          "name": "Pune to Thane Round Trip Cab",
          description: "Book a round-trip cab from Pune to Thane with AB Ghule Cabs. We provide reliable services with experienced drivers, ensuring a comfortable and timely round-trip journey from Pune to Thane."
        },
        {
          "name": "Pune to Kurla Dadar Taxi",
          description: "Book a taxi from Pune to Kurla or Dadar with AB Ghule Cabs. We offer comfortable, reliable, and affordable taxi services for your journey from Pune to these key locations in Mumbai."
        },
        {
          "name": "Pune to Thane Tempo Traveller on Rent",
          description: "For group travel, rent a Tempo Traveller from Pune to Thane with AB Ghule Cabs. Our spacious and well-maintained vehicles ensure comfort and safety for all passengers, making it perfect for group tours or events."
        },
        {
          "name": "Pune Thane Round Trip Cab",
          description: "AB Ghule Cabs offers round-trip cab services from Pune to Thane. Enjoy a hassle-free ride with experienced drivers and well-maintained vehicles, ensuring comfort and reliability throughout your journey."
        },
        {
          "name": "Pune to Thane Innova Cab",
          description: "Travel from Pune to Thane in style with AB Ghule Cabs’ Innova cab services. Our well-maintained Innova vehicles offer a comfortable, luxurious, and safe ride for your journey."
        },
        {
          "name": "Pune to Thane Cab Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Thane Cab. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData : [
        ["- Thane to Pune Cab fare", "- Cab from thane to Pune"],
        ["- Pune to kalyan cab service", "- Pune Thane Taxi"],
        ["- Pune to thane cab booking", "- Pune to thane cab fare"],
        ["- Pune to thane cab service", "- Pune to thane one way cab"],
        ["- Pune to thane taxi service", "- Thane to Pune Cab Booking"],
        ["- Pune to badlapur cab", "- Pune to vasai virar cab"],
        ["- Pune to vashi cab", "- Pune to thane one way cab"],
        ["- Pune to thane round trip cab", "- Pune to kurla dadar taxi"],
        ["- Pune to thane tempo traveller on rent", "- Pune thane round trip cab"],
        ["- Pune to Thane Innova Cab", ""]
      ],
      
      whychoose : [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs offers reliable and professional Pune to Thane cab services. Our experienced drivers ensure a smooth, safe, and comfortable journey, whether you’re traveling for business, leisure, or any other purpose."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We are available 24/7 to cater to your travel needs. Whether you need an early morning cab or a late-night ride, AB Ghule Cabs is always ready to serve you with reliable and timely services for your Pune to Thane trip."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "Our pricing is designed to be competitive and transparent, offering excellent value for money. There are no hidden charges, and our rates are suitable for all budgets, ensuring you get the best deal for your journey."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "Our fleet consists of well-maintained, clean vehicles to ensure a comfortable and safe ride. From economical sedans to more luxurious options, we have a vehicle that suits your travel preferences and group size."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Your safety is our priority. All of our drivers are background-checked and well-trained to ensure a secure and enjoyable journey. Our vehicles are equipped with GPS and other safety features to guarantee a smooth ride between Pune and Thane."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a cab with AB Ghule Cabs is easy and convenient. You can book your ride through our website, mobile app, or by calling our customer service team. We ensure quick, hassle-free booking for a seamless travel experience."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "With numerous positive reviews and repeat customers, we pride ourselves on delivering excellent service. Customer satisfaction is at the heart of everything we do, and we strive to make every trip enjoyable and stress-free."
        }
      ]
      
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Pune to Thane cab with AB Ghule Cabs?',
      answer: 'You can easily book your cab through our website, mobile app, or by calling our customer service team for immediate assistance.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are highly trained, experienced, and background-checked to ensure a safe, professional, and reliable experience.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a variety of vehicles including sedans, SUVs, and luxury cars, so you can choose the one that suits your needs, whether you\'re traveling alone or with a group.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'We offer several payment options, including cash, credit/debit cards, and online payment through our mobile app, so you can choose the method that’s most convenient for you.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, but we ensure full transparency in pricing. Any extra charges will be communicated to you before the trip.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can modify or cancel your booking easily through our website or app. Our customer service team is also available to assist with any changes or cancellations.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer one-way and round-trip services?',
      answer: 'Yes, we offer both one-way and round-trip services for your Pune to Thane journey, allowing you to choose the best option based on your travel plans.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Yes, we provide spacious vehicles for group travel, ensuring your family, friends, or colleagues can travel together comfortably.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other cab services?',
      answer: 'AB Ghule Cabs stands out for its commitment to customer satisfaction, affordable pricing, professional drivers, and a wide range of vehicles. We prioritize your comfort, safety, and convenience.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Amit Joshi",
      feedback: "I used AB Ghule Cabs for my trip from Pune to Thane, and I had a fantastic experience. The driver was punctual, the car was comfortable, and the entire trip was smooth and enjoyable. Highly recommended!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Priya Malhotra",
      feedback: "I recently traveled from Pune to Thane with AB Ghule Cabs for a business meeting. The driver was professional, the vehicle was clean, and the ride was extremely comfortable. I’ll definitely choose them for my next trip!",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Thane Cab Service | Taxi Booking</title>
  <meta name="description" content="Book Pune to Thane cab services with AB Ghule Cabs. Offering affordable fares for one-way and round-trip cabs, including Innova, Tempo Traveller, and more. Call +91 8624029699 for booking." />
  <meta name="keywords" content="Thane to Pune Cab fare, Cab from Thane to Pune, Pune to Kalyan cab service, Pune Thane Taxi, Pune to Thane cab booking, Pune to Thane cab fare, Pune to Thane cab service, Pune to Thane one way cab, Pune to Thane taxi service, Thane to Pune Cab Booking, Pune to Badlapur cab, Pune to Vasai Virar cab, Pune to Vashi cab, Pune to Thane one way cab, Pune to Thane round trip cab, Pune to Kurla Dadar taxi, Pune to Thane Tempo Traveller on rent, Pune Thane round trip cab, Pune to Thane Innova Cab" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Thane Cab Service | Taxi Booking" />
  <meta property="og:description" content="Book Pune to Thane cab services with AB Ghule Cabs. Offering affordable fares for one-way and round-trip cabs, including Innova, Tempo Traveller, and more. Call +91 8624029699 for booking." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-thane-cab.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-thane-cab" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "AB Ghule Cabs - Pune to Thane Cab Service",
        description: "Book Pune to Thane cab services with AB Ghule Cabs. Offering affordable fares for one-way and round-trip cabs, including Innova, Tempo Traveller, and more. Call +91 8624029699 for booking.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-thane-cab",
        "logo": "https://abghulecabs.com/images/pune-to-thane-cab.jpg",
        "image": "https://abghulecabs.com/images/pune-to-thane-cab.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-thane-cab",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Kiran B"
            },
            "datePublished": "2024-11-18",
            "reviewBody": "The cab service from Pune to Thane was excellent. The driver was punctual and the car was clean. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali S"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "I booked a round-trip cab from Pune to Thane. The pricing was affordable, and the service was smooth. Great experience!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Thane",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-thane-cab"
        },
        "keywords": "Thane to Pune Cab fare, Cab from Thane to Pune, Pune to Kalyan cab service, Pune Thane Taxi, Pune to Thane cab booking, Pune to Thane cab fare, Pune to Thane cab service, Pune to Thane one way cab, Pune to Thane taxi service, Thane to Pune Cab Booking, Pune to Badlapur cab, Pune to Vasai Virar cab, Pune to Vashi cab, Pune to Thane one way cab, Pune to Thane round trip cab, Pune to Kurla Dadar taxi, Pune to Thane Tempo Traveller on rent, Pune Thane round trip cab, Pune to Thane Innova Cab"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/69.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetothanecabs;